import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Directive, ElementRef, Inject, PLATFORM_ID, Renderer2 } from '@angular/core';

@Directive({
  selector: '[lazybg]',
  standalone: true,
})
export class LazybgDirective implements AfterViewInit {
  constructor(
    private el: ElementRef<HTMLElement>,
    private renderer: Renderer2,
    @Inject(PLATFORM_ID) private platformId: any,
  ) {
    if (isPlatformBrowser(this.platformId)) {
      const lazyImage = this.el.nativeElement;
      this.renderer.addClass(lazyImage, 'background-lazy-image');
    }
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      const lazyImage = this.el.nativeElement;
      const lazyImageObserver = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const target = entry.target;
              this.renderer.removeClass(target, 'background-lazy-image');
              lazyImageObserver.unobserve(target);
            }
          });
        },
        { rootMargin: '50px 0px ' },
      );
      lazyImageObserver.observe(lazyImage);
    }
  }
}
